<template>
  <button
    class="cell-break"
    type="button"
    v-bind:class="{ 'cell-break--single-row': isOneRowLayout }"
    v-on:click="onClick"
  >
    <template v-if="isOneRowLayout">
      <div class="cell-break__row">
        Перерыв
        <span class="cell-break__time cell-break__time--row">{{ interval }}</span>
      </div>
    </template>
    <template v-else-if="isDefaultLayout">
      <span class="cell-break__name">{{ breakTitle }}</span>
      <span class="cell-break__time">{{ interval }}</span>
    </template>
    <div
      class="cell-break__hover"
      v-bind:style="{ height: processedHeight }"
      ref="cellBreakPopup"
    >
      <b class="cell-break__title">Перерыв</b>
      <span v-if="note" class="cell-break__note"><b>Примечание: </b>{{ note }}</span>
      <span class="cell-break__full-time"><b>Время: </b>{{ interval }}</span>
    </div>
  </button>
</template>

<script>

/**
 * @description Название события открытия.
 * @type {string}
 */
const NAME_EVENT_OPEN = 'open';

/**
 * @description Высота единичного шага.
 * @type {number}
 */
const STEP_HEIGHT = 53;

/**
 * @description Компонент слота перерыва.
 * @type {Vue}
 */
export default {
  mounted() {
    this.cellBreakPopup = this.$refs.cellBreakPopup;
  },
  data() {
    return {
      cellBreakPopup: null,
    };
  },
  computed: {
    isOneRowLayout() {
      return this.tags.includes('one-row-layout');
    },
    isDefaultLayout() {
      return this.tags.includes('only-color-layout') === false;
    },
    breakTitle() {
      const text = 'Перерыв';
      return this.note ? `${text}: ${this.note}` : text;
    },
    /**
     * @description Вычисленное значение для высоты расширенного попапа.
     * @type {string}
     */
    processedHeight() {
      if (!this.cellBreakPopup) {
        return '';
      }
      const selfHeight = this.ratioStep * STEP_HEIGHT;
      const cellBreakPopupHeight = this.cellBreakPopup.offsetHeight;
      return selfHeight > cellBreakPopupHeight ? '100%' : 'fit-content';
    },
  },
  methods: {
    /**
     * @description Обработать нажатие.
     * @returns {void}
     */
    onClick() {
      this.$emit(NAME_EVENT_OPEN);
    },
  },
  name: 'TimetableBreakCell',
  props: {
    interval: { required: true, type: String },
    note: { default: '', type: String },
    tags: { required: true, type: Array },
    title: { default: '', type: String },
    ratioStep: { required: true, type: Number },
  },
};
</script>

<style scoped lang="scss">

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.cell-break {
  $this: &;

  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 8px 14px;
  background-color: var(--unfocus-color);
  height: 100%;
  width: 100%;

  &--single-row {
    padding-block: 0;
  }
  &__row {
    width: 100%;
    font-size: 12px;
    white-space: nowrap;
    color: #192a3e;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  &__title {
    margin-bottom: 4px;
    font-size: 14px;
  }
  &__name {
    text-align: left;
    font-weight: 400;
    font-size: 10px;
    color: #192a3e;
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
  }
  &__time {
    color: #192a3e;
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    margin: 4px 0 0 0;
    &--row {
      font-size: inherit;
      white-space: nowrap;
    }
  }
  &:hover {
    #{$this}__hover {
      display: flex;
      flex-direction: column;
      animation-name: fadeInOpacity;
      animation-iteration-count: 1;
      animation-timing-function: ease-in;
      animation-duration: 250ms;
      visibility: visible;
    }
  }
  &__hover {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: fit-content;
    padding: 8px 14px;
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    color: #192a3e;
    background-color: var(--unfocus-color);
    border-end-end-radius: var(--block-border-radius);
    border-end-start-radius: var(--block-border-radius);
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    visibility: hidden;
    z-index: 2;
  }
}
</style>
